module.exports = __webpack_public_path__ + "static/media/paik.b8540b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/paik.jpg
// module id = 840
// module chunks = 6